import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

export const handleConfirmation = (_handleYes,_handleNo,cb=null) => {
    return(
        confirmAlert({
            title: 'Are You Sure?',
            message: 'Are you sure to perform this action? This is irreversible.',
            buttons: [
              {
                label: 'Yes',
                onClick: () => _handleYes(),
              },
              {
                label: 'No',
                onClick: () => _handleNo(),
              }
            ]
        })
    )
};